"use client";

import { Modal } from "@/modules/common/components/modal";
import { Button } from "@/modules/common/components/button";
import { useLogOutModalStore, useLocationStore, useRegionStore } from "@/store/index";
import { signOutCustomer } from "@/modules/customer/actions/customer";
import { useCustomer } from "@/contexts/customer-context";
import { useParams, useRouter } from "next/navigation";
import { useQueryClient } from "@tanstack/react-query";

export const LogoutModal = () => {
  const { isOpen, hideModal } = useLogOutModalStore();
  const { refreshCustomer } = useCustomer();
  const router = useRouter();
  const params = useParams();
  const queryClient = useQueryClient();
  const countryCode = (params?.countryCode as string) || "cu";

  const clearLocation = useLocationStore((s) => s.clearLocation);
  const clearRegion = useRegionStore((s) => s.clearRegion);

  const confirmLogout = async () => {
    try {
      await signOutCustomer();
      // Clear all query cache to remove previous user's data
      await queryClient.clear();
      // Clear persisted location/region so next login starts fresh
      clearLocation();
      clearRegion();
      await refreshCustomer();
      router.replace(`/${countryCode}`);
    } catch (err) {
      console.error("Logout error:", err);
      // Still clear cache and stores even if logout fails
      await queryClient.clear();
      clearLocation();
      clearRegion();
      await refreshCustomer();
      router.replace(`/${countryCode}`);
    } finally {
      hideModal();
    }
  };

  return (
    <Modal isOpen={isOpen} close={hideModal} className="bg-cream">
      <div className="flex flex-col items-center justify-center p-4">
        <h3 className="font-achiko text-orange-main mb-8 text-center text-xl font-bold">
          ¿Está seguro que desea abandonar su sesión?
        </h3>

        <div className="flex w-full gap-4">
          <Button
            variant="outline"
            onClick={hideModal}
            className="text-green-main hover:bg-orange-main hover:border-orange-main flex-1 border-2 bg-transparent py-6 font-bold transition-all hover:text-white"
          >
            Cancelar
          </Button>
          <Button
            onClick={confirmLogout}
            className="bg-green-main flex-1 py-6 font-bold text-white hover:bg-[#047a2e]"
          >
            Salir
          </Button>
        </div>
      </div>
    </Modal>
  );
};
